<main class="tw-font-medium tw-text-gray-700 tw-bg-white">
  <app-home-header></app-home-header>

  <app-home-hero></app-home-hero>

  <app-home-faq *ngIf="showItem"></app-home-faq>

  <app-home-footer></app-home-footer>
</main>
